import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { TitleService } from './title.service';
import { PagePreloaderService } from './page-preloader.service';
import loader from '../loader';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { ProgressbarService } from './core/progressbar/progressbar.service';
import { InfoBannersService } from './shared/info-banners.service';
import { AppSettingsService } from './shared/app-settings/app-settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('pageAnimation', [
      state('*', style({opacity: 1})),
      state('hide', style({opacity: 0.2})),
      state('show', style({opacity: 1})),
      transition('* <=> *', animate('.25s'))
    ]),

  ]
})
export class AppComponent implements OnInit {

	public showNotPaidTariffBanner = false;
	public showDiscountBanner = false;

  public notieOptions = {
    timeOut: 3000,
    theClass: 'custom',
    position: ['top', 'right'],
    showProgressBar: false,
    pauseOnHover: true,
    clickToClose: true,
    animate: 'fromRight'
    // TODO: Не работает, создал issue на github (https://github.com/flauc/angular2-notifications/issues/165)
    // icons: {
    //   success: '<i class="ico ok_green"></i>'
    // }
  };

  public loading = 'hide';

  constructor(
		private infoBanners: InfoBannersService,
		public appSettings: AppSettingsService,
    private title: TitleService,
    private preloader: PagePreloaderService,
        private progress: ProgressbarService,
        private router: Router
  ) {
		infoBanners.banners.subscribe(banners => {
			if (banners.not_paid_banner) {
				this.showNotPaidTariffBanner = banners.not_paid_banner.show;
			}
			if (banners.trial_discount_banner) {
				this.showDiscountBanner = banners.trial_discount_banner.show;
			}
		});
    title.bindTitleChanges();
    this.setPreloader();
  }

    ngOnInit () {
        this.router.events.subscribe( ( e ) => {
            if ( e instanceof NavigationStart ) {
                (<any>window).gdeslon_q.push({
                    page_type:   'other',
                    merchant_id: '9412',
                    order_id:    '',
                    category_id: '',
                    products: [],
                    deduplication: ''
                });
            }
        } );
    }

  private setPreloader() {
    this.preloader.bindChangeRoute();
    this.preloader.isLoading.filter(loadingState => loadingState).subscribe(() => this.progress.start());
    this.preloader.isLoading.filter(loadingState => !loadingState).subscribe(() => this.progress.finish());
    this.preloader.isLoading.subscribe(isLoading => {
      // При смене роута скрываеем контент
      this.loading = isLoading ? 'hide' : 'show';
      // Закрываем прелоадер после подгрузки первого роута
      if (!isLoading) {
        loader.finish();
      }
    });
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/app.component.ts